export default "__VITE_ASSET__cs6dKcKH__";